export default {
  title: {
    fontFamily: 'Amariya, serif',
    letterSpacing: 0,
    marginBlockEnd: 0
  },
  preTitle: {
    fontFamily: 'Amariya, serif',
    letterSpacing: 0
  },
  contentContainerStyles: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 16px',
    'screen-large': {
      padding: '32px 112px'
    }
  },
  additionalBackgroundPictureStyles: {
    height: '260px',
    'screen-large': {
      height: '292px'
    }
  }
}
